import { useWindowLevel } from '@/hooks/use-window-level';
import { cn } from '@/lib/utils';

export interface WindowLevelIndicatorProps {
    /**
     * Offset the badge below a slider docked at the top of the viewport (the CPR
     * angle slider) so the two don't overlap. Defaults to the top-left corner.
     */
    clearTopSlider?: boolean;
}

/**
 * Read-only badge showing the live window/level value in the viewport's
 * top-left corner. Portaled into the per-viewport 'wl' slot by
 * WindowLevelIndicatorManager. Updates live during W/L drags and preset preview.
 */
export function WindowLevelIndicator({ clearTopSlider = false }: WindowLevelIndicatorProps) {
    const { window, level } = useWindowLevel();

    return (
        <div
            className={cn(
                'absolute z-10 pointer-events-none select-none',
                clearTopSlider ? 'top-5 right-4' : 'top-4 right-5',
                'flex items-center gap-1.5',
                'shadow-sm',
                'px-2 py-0.5 text-xs font-bold bg-foreground/50 text-muted tabular-nums'
            )}
        >
            <span>
                W <span className="font-normal text-muted/80">{Math.floor(window)}</span>
            </span>
            <span>
                L <span className="font-normal text-muted/80">{Math.floor(level)}</span>
            </span>
        </div>
    );
}
